import { ref, onMounted, onBeforeUnmount } from "vue";
import { useTranslationStore } from "@/stores/translations";
import { useNuxtApp } from "#app";

export const useFormContact = () => {
  const nuxtApp = useNuxtApp();

  const isLoading = ref(false);
  const LoadingTitle = ref("Loading...");
  const formSuccess = ref(false);
  const formTitle = ref("Contact Us Form");
  const formMessage = ref(null);
  const showModal = ref(false);
  const privacyStatement = ref(false);

  const translationStore = useTranslationStore();
  const translate = translationStore.translate;

  const submitForm = async (event) => {
    
    try {

      const token = await nuxtApp.$recaptcha.execute("submit");
      const form = event.target;
      const formData = new FormData(form);

      formData.append("name", 'Contact Us');
      formData.append("template", 'contact');
      formData.append("g-recaptcha-response", token);

      const { baseApi } = useApiBase();

      isLoading.value = true;
      LoadingTitle.value = "Sending ...";
      formSuccess.value = false;

      await $fetch(`${baseApi}/mail/contact`, {
        method: "POST",
        headers: {
          "X-CSRF-TOKEN": "NUXT",
        },
        body: formData,
      }).then(
        (data) => {
          if (data && data.status == "success") {
            formSuccess.value = true;
            formMessage.value = data.data;
            privacyStatement.value = false;
            form.reset()
          } else {
            formSuccess.value = false;
            formMessage.value = data.data;
          }
        },
        (error) => {
          formSuccess.value = false;
          formMessage.value = "error usefetch:" + error;
        }
      );
    } catch (error) {
      formMessage.value = "error catch:" + error;
      formSuccess.value = false;
    }

    showModal.value = true;
    isLoading.value = false;
  };

  const resetModal = () => {
    showModal.value = false; // รีเซ็ตค่า showModal เมื่อ Modal ถูกปิด
  };

  onMounted(() => {
    nuxtApp.$recaptcha.init();
    nuxtApp.$recaptcha.hideBadge = false;

    // Fetch translations
    translationStore.fetchTranslations();
  });

  onBeforeUnmount(() => {
    nuxtApp.$recaptcha.destroy();
  });

  return {
    isLoading,
    LoadingTitle,
    formSuccess,
    formTitle,
    formMessage,
    showModal,
    privacyStatement,
    translate,
    submitForm,
    resetModal,
  };
};